export default __webpack_public_path__ + "static/media/hero.3cb368b4.png";